<template>
  <div
    id="guest-flow"
    class="d-flex flex-column vh-100 overflow-x-hidden"
    :style="appStyleProps">
    <div class="flex-grow-1 d-flex flex-column" :class="{ 'customized-affiliate': !!affiliateCustomizations }">
      <div>
        <LayoutBase />
      </div>
      <div v-if="showAppHeader" class="d-block">
        <TenantAppHeader :portal="isLoggedIn"/>
      </div>
      <div class="flex-grow-1">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useRootStore } from '~/store/root';
import LayoutBase from './base.vue'
import TenantAppHeader from '~/components/tenant/TenantAppHeader';

export default {
  components: {
    TenantAppHeader,
    LayoutBase,
  },
  setup() {
    const windowSize = ref(window?.innerWidth ?? 0)

    const windowResize = () => {
      windowSize.value = window?.innerWidth
    }

    onMounted(() => {
      window?.addEventListener('resize', windowResize)
    })
    onUnmounted(() => {
      window?.removeEventListener('resize', windowResize)
    })

    return {
      windowSize
    }
  },
  computed: {
    isMobile() {
      return this.windowSize < 768
    },
    ...mapState(useAffiliateCustomizationStore, [
      'appStyleProps',
      'affiliateCustomizations',
      'iframeHeaderVisible',
    ]),
    ...mapState(useRootStore, [
      'isLoggedIn',
      'isEmbedded',
    ]),
    showAppHeader() {
      return !this.isEmbedded || !this.isLoggedIn || !this.iframeHeaderVisible
    },
  }
}
</script>

<style lang="scss" scoped>
:deep(.customized-affiliate) {
  @include affiliateCustomizedApp();
  height: initial !important;
}

#guest-flow > .customized-affiliate {
  background: $app-body-background-color;
}
</style>
